import { apiClient } from '@/shared/api/client';
import type { ApiResponse } from '@/shared/types/api.types';
import type {
  Experience,
  CreateExperienceRequest,
  UpdateExperienceRequest,
} from '@/features/experiences/types/experience.types';

const AUTH_BASE = '/candidate/experiences';
function publicBase(shareId: string): string {
  return `/public/candidates/${shareId}/experiences`;
}

export const candidateExperienceService = {
  list: async (): Promise<Experience[]> =>
    (await apiClient<ApiResponse<Experience[]>>(AUTH_BASE, { method: 'GET' })).data,

  create: async (request: CreateExperienceRequest): Promise<Experience> =>
    (await apiClient<ApiResponse<Experience>>(AUTH_BASE, { method: 'POST', body: request })).data,

  update: async (id: string, request: UpdateExperienceRequest): Promise<Experience> =>
    (
      await apiClient<ApiResponse<Experience>>(`${AUTH_BASE}/${id}`, {
        method: 'PUT',
        body: request,
      })
    ).data,

  delete: async (id: string): Promise<void> => {
    await apiClient(`${AUTH_BASE}/${id}`, { method: 'DELETE' });
  },

  listByShareId: async (shareId: string): Promise<Experience[]> =>
    (await apiClient<ApiResponse<Experience[]>>(publicBase(shareId), { method: 'GET' })).data,

  createByShareId: async (shareId: string, request: CreateExperienceRequest): Promise<Experience> =>
    (
      await apiClient<ApiResponse<Experience>>(publicBase(shareId), {
        method: 'POST',
        body: request,
      })
    ).data,

  updateByShareId: async (
    shareId: string,
    id: string,
    request: UpdateExperienceRequest
  ): Promise<Experience> =>
    (
      await apiClient<ApiResponse<Experience>>(`${publicBase(shareId)}/${id}`, {
        method: 'PUT',
        body: request,
      })
    ).data,

  deleteByShareId: async (shareId: string, id: string): Promise<void> => {
    await apiClient(`${publicBase(shareId)}/${id}`, { method: 'DELETE' });
  },
};
